<template>
<div class="chapter">
<div class="inner_page">
<p class="ded-title"><span>DEDICATION</span></p>
<p class="ded">I would like to dedicate this book as follows:</p>
<p class="ded2">Chapter One is dedicated to Brian Garfield.</p>
<p class="ded1">Chapter Five is dedicated to Abby Adams.</p>
<p class="ded1">Chapter Seven is dedicated to Justin Scott.</p>
<p class="ded1">Chapter Thirty-four is dedicated to Joan Rivers.</p>
<p class="ded1">Chapter Thirty-five is dedicated to George Movshon.</p>
<p class="ded1">Chapter Thirty-nine is dedicated to Pete Martin.</p>
<p class="ded1">Chapter Forty-three is dedicated to Rich Barber.</p>
<p class="ded">And all the other Chapters are dedicated to You, dear reader, with my thanks.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?4e467e00